// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CareOrchestration-module__root___Ea4DY {
  font-family: "IBM Plex Sans", -apple-system, sans-serif;
  background: #fafafa;
  height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 22px);
  color: #18181b;
  display: flex;
  flex-direction: column;
}

.CareOrchestration-module__root___Ea4DY,
.CareOrchestration-module__root___Ea4DY * {
  box-sizing: border-box;
}

.CareOrchestration-module__content___ovFk8 {
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
  scrollbar-width: none;
}

.CareOrchestration-module__contentInner___GoGDZ {
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 20px 56px;
  width: 100%;
}

.CareOrchestration-module__content___ovFk8::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.CareOrchestration-module__emptyState___zkQJc {
  min-height: 240px;
  border: 1px dashed #d4d4d8;
  border-radius: 12px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 24px;
  text-align: center;
}

.CareOrchestration-module__emptyStateTitle___NKwES {
  font-size: 18px;
  font-weight: 600;
  color: #18181b;
}

.CareOrchestration-module__emptyStateText____CjHD {
  max-width: 420px;
  font-size: 14px;
  color: #71717a;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/CareOrchestration.module.scss"],"names":[],"mappings":"AAAA;EACE,uDAAA;EACA,mBAAA;EACA,iHAAA;EAIA,cAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;;EAEE,sBAAA;AAFF;;AAKA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;AAFF;;AAKA;EACE,QAAA;EACA,SAAA;AAFF;;AAKA;EACE,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAFF","sourcesContent":[".root {\n  font-family: 'IBM Plex Sans', -apple-system, sans-serif;\n  background: #fafafa;\n  height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) -\n      22px\n  );\n  color: #18181b;\n  display: flex;\n  flex-direction: column;\n}\n\n.root,\n.root * {\n  box-sizing: border-box;\n}\n\n.content {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  scrollbar-width: none;\n}\n\n.contentInner {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 16px 20px 56px;\n  width: 100%;\n}\n\n.content::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.emptyState {\n  min-height: 240px;\n  border: 1px dashed #d4d4d8;\n  border-radius: 12px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 32px 24px;\n  text-align: center;\n}\n\n.emptyStateTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.emptyStateText {\n  max-width: 420px;\n  font-size: 14px;\n  color: #71717a;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CareOrchestration-module__root___Ea4DY`,
	"content": `CareOrchestration-module__content___ovFk8`,
	"contentInner": `CareOrchestration-module__contentInner___GoGDZ`,
	"emptyState": `CareOrchestration-module__emptyState___zkQJc`,
	"emptyStateTitle": `CareOrchestration-module__emptyStateTitle___NKwES`,
	"emptyStateText": `CareOrchestration-module__emptyStateText____CjHD`
};
module.exports = ___CSS_LOADER_EXPORT___;
